import React, { useContext, useState, useRef, useEffect, useReducer, useCallback } from 'react';
import PropTypes from 'prop-types';
import { IconSvg, Tooltip, Switch, Button } from '@jobandtalent/design-system';
import cx from 'classnames';

function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$2(Object(source), true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray$1(arr, i) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$1(arr);
}

function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit$1(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray$1(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}

function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Logger);

    this.init(concreteLogger, options);
  }

  _createClass(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, _objectSpread$2({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }, this.options));
    }
  }]);

  return Logger;
}();

var baseLogger = new Logger();

var EventEmitter = function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this.observers = {};
  }

  _createClass(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;

      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];

        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;

      if (!listener) {
        delete this.observers[event];
        return;
      }

      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }

      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);

        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);

  return EventEmitter;
}();

function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');

  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();

    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);

  if (value !== undefined) {
    return value;
  }

  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }

  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function escape$1(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;

function deepFind(obj, path) {
  var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  if (!obj) return undefined;
  if (obj[path]) return obj[path];
  var paths = path.split(keySeparator);
  var current = obj;

  for (var i = 0; i < paths.length; ++i) {
    if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) {
      return undefined;
    }

    if (current[paths[i]] === undefined) {
      var j = 2;
      var p = paths.slice(i, i + j).join(keySeparator);
      var mix = current[p];

      while (mix === undefined && paths.length > i + j) {
        j++;
        p = paths.slice(i, i + j).join(keySeparator);
        mix = current[p];
      }

      if (mix === undefined) return undefined;
      if (typeof mix === 'string') return mix;
      if (p && typeof mix[p] === 'string') return mix[p];
      var joinedPath = paths.slice(i + j).join(keySeparator);
      if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
      return undefined;
    }

    current = current[paths[i]];
  }

  return current;
}

var ResourceStore = function (_EventEmitter) {
  _inherits(ResourceStore, _EventEmitter);

  function ResourceStore(data) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };

    _classCallCheck(this, ResourceStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResourceStore).call(this));

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.data = data || {};
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    if (_this.options.ignoreJSONStructure === undefined) {
      _this.options.ignoreJSONStructure = true;
    }

    return _this;
  }

  _createClass(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);

      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }

      var result = getPath(this.data, path);
      if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
      return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === undefined) keySeparator = '.';
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };

      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }

      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};

      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = _objectSpread$2({}, pack, resources);
      }

      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }

      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === 'v1') return _objectSpread$2({}, {}, this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);

  return ResourceStore;
}(EventEmitter);

var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

var checkedLoadedFor = {};

var Translator = function (_EventEmitter) {
  _inherits(Translator, _EventEmitter);

  function Translator(services) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Translator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Translator).call(this));

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, _assertThisInitialized(_this));
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = baseLogger.create('translator');
    return _this;
  }

  _createClass(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS;

      if (nsSeparator && key.indexOf(nsSeparator) > -1) {
        var m = key.match(this.interpolator.nestingRegexp);

        if (m && m.length > 0) {
          return {
            key: key,
            namespaces: namespaces
          };
        }

        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }

      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options, lastKey) {
      var _this2 = this;

      if (_typeof(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }

      if (!options) options = {};
      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)];
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
          key = _this$extractFromKey.key,
          namespaces = _this$extractFromKey.namespaces;

      var namespace = namespaces[namespaces.length - 1];
      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;
          return namespace + nsSeparator + key;
        }

        return key;
      }

      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';

      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          if (!this.options.returnedObjectHandler) {
            this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          }

          return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$2({}, options, {
            ns: namespaces
          })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
        }

        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;

          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy[m] = this.translate(deepKey, _objectSpread$2({}, options, {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy[m] === deepKey) copy[m] = res[m];
            }
          }

          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var hasDefaultValue = Translator.hasDefaultValue(options);
        var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count) : '';
        var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;

        if (!this.isValidLookup(res) && hasDefaultValue) {
          usedDefault = true;
          res = defaultValue;
        }

        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }

        var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;

        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);

          if (keySeparator) {
            var fk = this.resolve(key, _objectSpread$2({}, options, {
              keySeparator: false
            }));
            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
          }

          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);

          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }

          var send = function send(l, k, fallbackValue) {
            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? fallbackValue : res, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? fallbackValue : res, updateMissing, options);
            }

            _this2.emit('missingKey', l, namespace, k, res);
          };

          if (this.options.saveMissing) {
            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (language) {
                _this2.pluralResolver.getSuffixes(language).forEach(function (suffix) {
                  send([language], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                });
              });
            } else {
              send(lngs, key, defaultValue);
            }
          }
        }

        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
        if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
      }

      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved, lastKey) {
      var _this3 = this;

      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation) this.interpolator.init(_objectSpread$2({}, options, {
          interpolation: _objectSpread$2({}, this.options.interpolation, options.interpolation)
        }));
        var skipOnVariables = options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
        var nestBef;

        if (skipOnVariables) {
          var nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }

        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = _objectSpread$2({}, this.options.interpolation.defaultVariables, data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);

        if (skipOnVariables) {
          var na = res.match(this.interpolator.nestingRegexp);
          var nestAft = na && na.length;
          if (nestBef < nestAft) options.nest = false;
        }

        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (lastKey && lastKey[0] === args[0] && !options.context) {
            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));

            return null;
          }

          return _this3.translate.apply(_this3, args.concat([key]));
        }, options);
        if (options.interpolation) this.interpolator.reset();
      }

      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$2({
          i18nResolved: resolved
        }, options) : options, this);
      }

      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys];
      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;

        var extracted = _this4.extractFromKey(k, options);

        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;

          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;

            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }

          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKey = key;
            var finalKeys = [finalKey];

            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count);
              if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);
              if (needsContextHandling) finalKeys.push(finalKey += "".concat(_this4.options.contextSeparator).concat(options.context));
              if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
            }

            var possibleKey;

            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }], [{
    key: "hasDefaultValue",
    value: function hasDefaultValue(options) {
      var prefix = 'defaultValue';

      for (var option in options) {
        if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
          return true;
        }
      }

      return false;
    }
  }]);

  return Translator;
}(EventEmitter);

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil = function () {
  function LanguageUtil(options) {
    _classCallCheck(this, LanguageUtil);

    this.options = options;
    this.whitelist = this.options.supportedLngs || false;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }

  _createClass(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      if (p[p.length - 1].toLowerCase() === 'x') return null;
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');

        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase();
          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }

        return p.join('-');
      }

      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isWhitelisted",
    value: function isWhitelisted(code) {
      this.logger.deprecate('languageUtils.isWhitelisted', 'function "isWhitelisted" will be renamed to "isSupportedCode" in the next major - please make sure to rename it\'s usage asap.');
      return this.isSupportedCode(code);
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }

      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;

      if (!codes) return null;
      var found;
      codes.forEach(function (code) {
        if (found) return;

        var cleanedLng = _this.formatLanguageCode(code);

        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
      });

      if (!found && this.options.supportedLngs) {
        codes.forEach(function (code) {
          if (found) return;

          var lngOnly = _this.getLanguagePartFromCode(code);

          if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
          found = _this.options.supportedLngs.find(function (supportedLng) {
            if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
          });
        });
      }

      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;

      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];

      var addCode = function addCode(c) {
        if (!c) return;

        if (_this2.isSupportedCode(c)) {
          codes.push(c);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
        }
      };

      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }

      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);

  return LanguageUtil;
}();

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kk', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');
    this.rules = createRules();
  }

  _createClass(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var rule = this.getRule(code);
      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      return this.getSuffixes(code).map(function (suffix) {
        return key + suffix;
      });
    }
  }, {
    key: "getSuffixes",
    value: function getSuffixes(code) {
      var _this = this;

      var rule = this.getRule(code);

      if (!rule) {
        return [];
      }

      return rule.numbers.map(function (number) {
        return _this.getSuffix(code, number);
      });
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var _this2 = this;

      var rule = this.getRule(code);

      if (rule) {
        var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        var suffix = rule.numbers[idx];

        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          if (suffix === 2) {
            suffix = 'plural';
          } else if (suffix === 1) {
            suffix = '';
          }
        }

        var returnSuffix = function returnSuffix() {
          return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
        };

        if (this.options.compatibilityJSON === 'v1') {
          if (suffix === 1) return '';
          if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
          return returnSuffix();
        } else if (this.options.compatibilityJSON === 'v2') {
          return returnSuffix();
        } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          return returnSuffix();
        }

        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
      }

      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }]);

  return PluralResolver;
}();

var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Interpolator);

    this.logger = baseLogger.create('interpolator');
    this.options = options;

    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };

    this.init(options);
  }

  _createClass(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : escape$1;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;

      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};

      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }

      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = getPathWithDefaults(data, defaultData, key);
          return _this.alwaysFormat ? _this.format(path, undefined, lng, _objectSpread$2({}, options, data, {
            interpolationkey: key
          })) : path;
        }

        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, _objectSpread$2({}, options, data, {
          interpolationkey: k
        }));
      };

      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function (todo) {
        replaces = 0;

        while (match = todo.regex.exec(str)) {
          value = handleFormat(match[1].trim());

          if (value === undefined) {
            if (typeof missingInterpolationHandler === 'function') {
              var temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === 'string' ? temp : '';
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(match[1], " for interpolating ").concat(str));

              value = '';
            }
          } else if (typeof value !== 'string' && !_this.useRawValueToEscape) {
            value = makeString(value);
          }

          var safeValue = todo.safeValue(value);
          str = str.replace(match[0], safeValue);

          if (skipOnVariables) {
            todo.regex.lastIndex += safeValue.length;
            todo.regex.lastIndex -= match[0].length;
          } else {
            todo.regex.lastIndex = 0;
          }

          replaces++;

          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;

      var clonedOptions = _objectSpread$2({}, options);

      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;

      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c[1]);
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        optionsString = optionsString.replace(/'/g, '"');

        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = _objectSpread$2({}, inheritedOptions, clonedOptions);
        } catch (e) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
          return "".concat(key).concat(sep).concat(optionsString);
        }

        delete clonedOptions.defaultValue;
        return key;
      }

      while (match = this.nestingRegexp.exec(str)) {
        var formatters = [];
        var doReduce = false;

        if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
          var r = match[1].split(this.formatSeparator).map(function (elem) {
            return elem.trim();
          });
          match[1] = r.shift();
          formatters = r;
          doReduce = true;
        }

        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== 'string') return value;
        if (typeof value !== 'string') value = makeString(value);

        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        }

        if (doReduce) {
          value = formatters.reduce(function (v, f) {
            return _this2.format(v, f, options.lng, _objectSpread$2({}, options, {
              interpolationkey: match[1].trim()
            }));
          }, value.trim());
        }

        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }

      return str;
    }
  }]);

  return Interpolator;
}();

function remove(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var Connector = function (_EventEmitter) {
  _inherits(Connector, _EventEmitter);

  function Connector(backend, store, services) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, Connector);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Connector).call(this));

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }

    return _this;
  }

  _createClass(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;

      var toLoad = [];
      var pending = [];
      var toLoadLanguages = [];
      var toLoadNamespaces = [];
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);

          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending.indexOf(name) < 0) pending.push(name);
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending.indexOf(name) < 0) pending.push(name);
            if (toLoad.indexOf(name) < 0) toLoad.push(name);
            if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
          }
        });
        if (!hasAllNamespaces) toLoadLanguages.push(lng);
      });

      if (toLoad.length || pending.length) {
        this.queue.push({
          pending: pending,
          loaded: {},
          errors: [],
          callback: callback
        });
      }

      return {
        toLoad: toLoad,
        pending: pending,
        toLoadLanguages: toLoadLanguages,
        toLoadNamespaces: toLoadNamespaces
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      if (err) this.emit('failedLoading', lng, ns, err);

      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      }

      this.state[name] = err ? -1 : 2;
      var loaded = {};
      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        remove(q.pending, name);
        if (err) q.errors.push(err);

        if (q.pending.length === 0 && !q.done) {
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = [];

            if (q.loaded[l].length) {
              q.loaded[l].forEach(function (ns) {
                if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
              });
            }
          });
          q.done = true;

          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit('loaded', loaded);
      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;

      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 350;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {});
      return this.backend[fcName](lng, ns, function (err, data) {
        if (err && data && tried < 5) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }

        callback(err, data);
      });
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;

      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }

      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);

      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback();
        return null;
      }

      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;

      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);

        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      }

      if (key === undefined || key === null || key === '') return;

      if (this.backend && this.backend.create) {
        this.backend.create(languages, namespace, key, fallbackValue, null, _objectSpread$2({}, options, {
          isUpdate: isUpdate
        }));
      }

      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);

  return Connector;
}(EventEmitter);

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    whitelist: false,
    nonExplicitWhitelist: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (_typeof(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];

      if (_typeof(args[2]) === 'object' || _typeof(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }

      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: false
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  if (options.whitelist) {
    if (options.whitelist && options.whitelist.indexOf('cimode') < 0) {
      options.whitelist = options.whitelist.concat(['cimode']);
    }

    options.supportedLngs = options.whitelist;
  }

  if (options.nonExplicitWhitelist) {
    options.nonExplicitSupportedLngs = options.nonExplicitWhitelist;
  }

  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }

  return options;
}

function noop$1() {}

var I18n = function (_EventEmitter) {
  _inherits(I18n, _EventEmitter);

  function I18n() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck(this, I18n);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(I18n).call(this));

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };

    if (callback && !_this.isInitialized && !options.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options, callback);

        return _possibleConstructorReturn(_this, _assertThisInitialized(_this));
      }

      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }

    return _this;
  }

  _createClass(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      if (options.whitelist && !options.supportedLngs) {
        this.logger.deprecate('whitelist', 'option "whitelist" will be renamed to "supportedLngs" in the next major - please make sure to rename this option asap.');
      }

      if (options.nonExplicitWhitelist && !options.nonExplicitSupportedLngs) {
        this.logger.deprecate('whitelist', 'options "nonExplicitWhitelist" will be renamed to "nonExplicitSupportedLngs" in the next major - please make sure to rename this option asap.');
      }

      this.options = _objectSpread$2({}, get(), this.options, transformOptions(options));
      this.format = this.options.interpolation.format;
      if (!callback) callback = noop$1;

      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      }

      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }

        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });
        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });

        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s.languageDetector.init(s, this.options.detection, this.options);
        }

        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }

        this.translator = new Translator(this.services, this.options);
        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      }

      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
      }

      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      }

      var storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;

          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
      storeApiChained.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store2;

          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);

          return _this2;
        };
      });
      var deferred = defer();

      var load = function load() {
        var finish = function finish(err, t) {
          if (_this2.isInitialized) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
          _this2.isInitialized = true;
          if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);

          _this2.emit('initialized', _this2.options);

          deferred.resolve(t);
          callback(err, t);
        };

        if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));

        _this2.changeLanguage(_this2.options.lng, finish);
      };

      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }

      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop$1;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;

      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
        var toLoad = [];

        var append = function append(lng) {
          if (!lng) return;

          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);

          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };

        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }

        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }

        this.services.backendConnector.load(toLoad, this.options.ns, usedCallback);
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop$1;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');

      if (module.type === 'backend') {
        this.modules.backend = module;
      }

      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }

      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }

      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }

      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }

      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }

      return this;
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;

      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);

      var done = function done(err, l) {
        if (l) {
          _this4.language = l;
          _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);

          _this4.translator.changeLanguage(l);

          _this4.isLanguageChangingTo = undefined;

          _this4.emit('languageChanged', l);

          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }

        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };

      var setLng = function setLng(lngs) {
        if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
        var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);

        if (l) {
          if (!_this4.language) {
            _this4.language = l;
            _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
          }

          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
        }

        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };

      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }

      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns) {
      var _this5 = this;

      var fixedT = function fixedT(key, opts) {
        var options;

        if (_typeof(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }

          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = _objectSpread$2({}, opts);
        }

        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        return _this5.t(key, options);
      };

      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }

      fixedT.ns = ns;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;

      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;

      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }

      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }

      var lng = this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === 'cimode') return true;

      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];

        return loadState === -1 || loadState === 2;
      };

      if (options.precheck) {
        var preResult = options.precheck(this, loadNotPending);
        if (preResult !== undefined) return preResult;
      }

      if (this.hasResourceBundle(lng, ns)) return true;
      if (!this.services.backendConnector.backend) return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;

      var deferred = defer();

      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }

      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      });

      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }

      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
    }
  }, {
    key: "createInstance",
    value: function createInstance() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      return new I18n(options, callback);
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop$1;

      var mergedOptions = _objectSpread$2({}, this.options, options, {
        isClone: true
      });

      var clone = new I18n(mergedOptions);
      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.services = _objectSpread$2({}, this.services);
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options;
      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages
      };
    }
  }]);

  return I18n;
}(EventEmitter);

var i18next = new I18n();

var arr = [];
var each = arr.forEach;
var slice = arr.slice;
function defaults(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}

// eslint-disable-next-line no-control-regex
var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

var serializeCookie = function serializeCookie(name, val, options) {
  var opt = options || {};
  opt.path = opt.path || '/';
  var value = encodeURIComponent(val);
  var str = name + '=' + value;

  if (opt.maxAge > 0) {
    var maxAge = opt.maxAge - 0;
    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) str += '; HttpOnly';
  if (opt.secure) str += '; Secure';

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;

      case 'lax':
        str += '; SameSite=Lax';
        break;

      case 'strict':
        str += '; SameSite=Strict';
        break;

      case 'none':
        str += '; SameSite=None';
        break;

      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
};

var cookie = {
  create: function create(name, value, minutes, domain) {
    var cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
      path: '/',
      sameSite: 'strict'
    };

    if (minutes) {
      cookieOptions.expires = new Date();
      cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60 * 1000);
    }

    if (domain) cookieOptions.domain = domain;
    document.cookie = serializeCookie(name, encodeURIComponent(value), cookieOptions);
  },
  read: function read(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');

    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];

      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }

      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }

    return null;
  },
  remove: function remove(name) {
    this.create(name, '', -1);
  }
};
var cookie$1 = {
  name: 'cookie',
  lookup: function lookup(options) {
    var found;

    if (options.lookupCookie && typeof document !== 'undefined') {
      var c = cookie.read(options.lookupCookie);
      if (c) found = c;
    }

    return found;
  },
  cacheUserLanguage: function cacheUserLanguage(lng, options) {
    if (options.lookupCookie && typeof document !== 'undefined') {
      cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
    }
  }
};

var querystring = {
  name: 'querystring',
  lookup: function lookup(options) {
    var found;

    if (typeof window !== 'undefined') {
      var query = window.location.search.substring(1);
      var params = query.split('&');

      for (var i = 0; i < params.length; i++) {
        var pos = params[i].indexOf('=');

        if (pos > 0) {
          var key = params[i].substring(0, pos);

          if (key === options.lookupQuerystring) {
            found = params[i].substring(pos + 1);
          }
        }
      }
    }

    return found;
  }
};

var hasLocalStorageSupport = null;

var localStorageAvailable = function localStorageAvailable() {
  if (hasLocalStorageSupport !== null) return hasLocalStorageSupport;

  try {
    hasLocalStorageSupport = window !== 'undefined' && window.localStorage !== null;
    var testKey = 'i18next.translate.boo';
    window.localStorage.setItem(testKey, 'foo');
    window.localStorage.removeItem(testKey);
  } catch (e) {
    hasLocalStorageSupport = false;
  }

  return hasLocalStorageSupport;
};

var localStorage = {
  name: 'localStorage',
  lookup: function lookup(options) {
    var found;

    if (options.lookupLocalStorage && localStorageAvailable()) {
      var lng = window.localStorage.getItem(options.lookupLocalStorage);
      if (lng) found = lng;
    }

    return found;
  },
  cacheUserLanguage: function cacheUserLanguage(lng, options) {
    if (options.lookupLocalStorage && localStorageAvailable()) {
      window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
  }
};

var hasSessionStorageSupport = null;

var sessionStorageAvailable = function sessionStorageAvailable() {
  if (hasSessionStorageSupport !== null) return hasSessionStorageSupport;

  try {
    hasSessionStorageSupport = window !== 'undefined' && window.sessionStorage !== null;
    var testKey = 'i18next.translate.boo';
    window.sessionStorage.setItem(testKey, 'foo');
    window.sessionStorage.removeItem(testKey);
  } catch (e) {
    hasSessionStorageSupport = false;
  }

  return hasSessionStorageSupport;
};

var sessionStorage = {
  name: 'sessionStorage',
  lookup: function lookup(options) {
    var found;

    if (options.lookupSessionStorage && sessionStorageAvailable()) {
      var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
      if (lng) found = lng;
    }

    return found;
  },
  cacheUserLanguage: function cacheUserLanguage(lng, options) {
    if (options.lookupSessionStorage && sessionStorageAvailable()) {
      window.sessionStorage.setItem(options.lookupSessionStorage, lng);
    }
  }
};

var navigator$1 = {
  name: 'navigator',
  lookup: function lookup(options) {
    var found = [];

    if (typeof navigator !== 'undefined') {
      if (navigator.languages) {
        // chrome only; not an array, so can't use .push.apply instead of iterating
        for (var i = 0; i < navigator.languages.length; i++) {
          found.push(navigator.languages[i]);
        }
      }

      if (navigator.userLanguage) {
        found.push(navigator.userLanguage);
      }

      if (navigator.language) {
        found.push(navigator.language);
      }
    }

    return found.length > 0 ? found : undefined;
  }
};

var htmlTag = {
  name: 'htmlTag',
  lookup: function lookup(options) {
    var found;
    var htmlTag = options.htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);

    if (htmlTag && typeof htmlTag.getAttribute === 'function') {
      found = htmlTag.getAttribute('lang');
    }

    return found;
  }
};

var path = {
  name: 'path',
  lookup: function lookup(options) {
    var found;

    if (typeof window !== 'undefined') {
      var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);

      if (language instanceof Array) {
        if (typeof options.lookupFromPathIndex === 'number') {
          if (typeof language[options.lookupFromPathIndex] !== 'string') {
            return undefined;
          }

          found = language[options.lookupFromPathIndex].replace('/', '');
        } else {
          found = language[0].replace('/', '');
        }
      }
    }

    return found;
  }
};

var subdomain = {
  name: 'subdomain',
  lookup: function lookup(options) {
    var found;

    if (typeof window !== 'undefined') {
      var language = window.location.href.match(/(?:http[s]*\:\/\/)*(.*?)\.(?=[^\/]*\..{2,5})/gi);

      if (language instanceof Array) {
        if (typeof options.lookupFromSubdomainIndex === 'number') {
          found = language[options.lookupFromSubdomainIndex].replace('http://', '').replace('https://', '').replace('.', '');
        } else {
          found = language[0].replace('http://', '').replace('https://', '').replace('.', '');
        }
      }
    }

    return found;
  }
};

function getDefaults$1() {
  return {
    order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag'],
    lookupQuerystring: 'lng',
    lookupCookie: 'i18next',
    lookupLocalStorage: 'i18nextLng',
    lookupSessionStorage: 'i18nextLng',
    // cache user language
    caches: ['localStorage'],
    excludeCacheFor: ['cimode'] //cookieMinutes: 10,
    //cookieDomain: 'myDomain'

  };
}

var Browser =
/*#__PURE__*/
function () {
  function Browser(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Browser);

    this.type = 'languageDetector';
    this.detectors = {};
    this.init(services, options);
  }

  _createClass(Browser, [{
    key: "init",
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.services = services;
      this.options = defaults(options, this.options || {}, getDefaults$1()); // backwards compatibility

      if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
      this.i18nOptions = i18nOptions;
      this.addDetector(cookie$1);
      this.addDetector(querystring);
      this.addDetector(localStorage);
      this.addDetector(sessionStorage);
      this.addDetector(navigator$1);
      this.addDetector(htmlTag);
      this.addDetector(path);
      this.addDetector(subdomain);
    }
  }, {
    key: "addDetector",
    value: function addDetector(detector) {
      this.detectors[detector.name] = detector;
    }
  }, {
    key: "detect",
    value: function detect(detectionOrder) {
      var _this = this;

      if (!detectionOrder) detectionOrder = this.options.order;
      var detected = [];
      detectionOrder.forEach(function (detectorName) {
        if (_this.detectors[detectorName]) {
          var lookup = _this.detectors[detectorName].lookup(_this.options);

          if (lookup && typeof lookup === 'string') lookup = [lookup];
          if (lookup) detected = detected.concat(lookup);
        }
      });
      if (this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0

      return detected.length > 0 ? detected[0] : null; // a little backward compatibility
    }
  }, {
    key: "cacheUserLanguage",
    value: function cacheUserLanguage(lng, caches) {
      var _this2 = this;

      if (!caches) caches = this.options.caches;
      if (!caches) return;
      if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
      caches.forEach(function (cacheName) {
        if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
      });
    }
  }]);

  return Browser;
}();

Browser.type = 'languageDetector';

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true
};
var i18nInstance;
var I18nContext = React.createContext();
function setDefaults() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = _objectSpread$1(_objectSpread$1({}, defaultOptions), options);
}
function getDefaults() {
  return defaultOptions;
}
var ReportNamespaces = function () {
  function ReportNamespaces() {
    _classCallCheck(this, ReportNamespaces);

    this.usedNamespaces = {};
  }

  _createClass(ReportNamespaces, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;

      namespaces.forEach(function (ns) {
        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);

  return ReportNamespaces;
}();
function setI18n(instance) {
  i18nInstance = instance;
}
function getI18n() {
  return i18nInstance;
}
var initReactI18next = {
  type: '3rdParty',
  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};

function warn() {
  if (console && console.warn) {
    var _console;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);

    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  warn.apply(void 0, args);
}
function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, function () {
    if (i18n.isInitialized) {
      cb();
    } else {
      var initialized = function initialized() {
        setTimeout(function () {
          i18n.off('initialized', initialized);
        }, 0);
        cb();
      };

      i18n.on('initialized', initialized);
    }
  });
}
function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!i18n.languages || !i18n.languages.length) {
    warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }

  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;

  var loadNotPending = function loadNotPending(l, n) {
    var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
    return loadState === -1 || loadState === 2;
  };

  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function useTranslation(ns) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var i18nFromProps = props.i18n;

  var _ref = useContext(I18nContext) || {},
      i18nFromContext = _ref.i18n,
      defaultNSFromContext = _ref.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || getI18n();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new ReportNamespaces();

  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using initReactI18next');

    var notReadyT = function notReadyT(k) {
      return Array.isArray(k) ? k[k.length - 1] : k;
    };

    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }

  if (i18n.options.react && i18n.options.react.wait !== undefined) warnOnce('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');

  var i18nOptions = _objectSpread(_objectSpread(_objectSpread({}, getDefaults()), i18n.options.react), props);

  var useSuspense = i18nOptions.useSuspense;
  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function (n) {
    return hasLoadedNamespace(n, i18n, i18nOptions);
  });

  function getT() {
    return i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0]);
  }

  var _useState = useState(getT),
      _useState2 = _slicedToArray(_useState, 2),
      t = _useState2[0],
      setT = _useState2[1];

  var isMounted = useRef(true);
  useEffect(function () {
    var bindI18n = i18nOptions.bindI18n,
        bindI18nStore = i18nOptions.bindI18nStore;
    isMounted.current = true;

    if (!ready && !useSuspense) {
      loadNamespaces(i18n, namespaces, function () {
        if (isMounted.current) setT(getT);
      });
    }

    function boundReset() {
      if (isMounted.current) setT(getT);
    }

    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return function () {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(function (e) {
        return i18n.off(e, boundReset);
      });
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function (e) {
        return i18n.store.off(e, boundReset);
      });
    };
  }, [i18n, namespaces.join()]);
  var isInitial = useRef(true);
  useEffect(function () {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }

    isInitial.current = false;
  }, [i18n]);
  var ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(function (resolve) {
    loadNamespaces(i18n, namespaces, function () {
      resolve();
    });
  });
}

var cookieConsent$8 = {
	intro: {
		title: "You need to accept cookies to continue surfing the site",
		body: {
			content: "We use them to make our site work and provide the best experience. By clicking Accept all or activating an option in the Cookies Preferences, you accept what is established in our {{link}}. To change your preferences or withdraw your consent, update your Cookie preferences.",
			link: {
				href: "https://jobandtalent.com/cookies",
				label: "Cookies Policy"
			}
		}
	},
	cookies: {
		technical: {
			title: "Technical cookies",
			subtitle: "Strictly necessary cookies",
			description: "Essential for the correct functioning of the site and to provide the service offered and requested by the users.",
			mandatory: {
				title: "Mandatory",
				description: "These cookies are necessary for the correct site performance"
			}
		},
		advertising: {
			title: "Advertising cookies",
			subtitle: "Optional Cookies",
			description: "They store information about user behaviour, which allows us to build a specific profile based on your browsing habits and to show you advertising based on that profile. They are used to make advertising messages more relevant to you and your interests."
		},
		analytical: {
			title: "Analytical cookies",
			subtitle: "Optional Cookies",
			description: "These are those which, whether processed by us or by third parties, allow us to quantify the number of users and thus to carry out the measurement and statistical analysis of the use made by users of the service offered. To this end, your browsing on our website is analysed in order to improve the products or services we offer you."
		}
	},
	actions: {
		settings: {
			open: "Cookie preferences",
			close: "Close"
		},
		accept: "Accept all",
		reject: "Reject"
	}
};
var translationEN = {
	cookieConsent: cookieConsent$8
};

var cookieConsent$7 = {
	intro: {
		title: "You need to accept cookies to continue surfing the site",
		body: {
			content: "We use them to make our site work and provide the best experience. By clicking Accept all or activating an option in the Cookies Preferences, you accept what is established in our {{link}}. To change your preferences or withdraw your consent, update your Cookie preferences.",
			link: {
				href: "https://jobandtalent.com/cookies",
				label: "Cookies Policy"
			}
		}
	},
	cookies: {
		technical: {
			title: "Technical cookies",
			subtitle: "Strictly necessary cookies",
			description: "Essential for the correct functioning of the site and to provide the service offered and requested by the users.",
			mandatory: {
				title: "Mandatory",
				description: "These cookies are necessary for the correct site performance"
			}
		},
		advertising: {
			title: "Advertising cookies",
			subtitle: "Optional Cookies",
			description: "They store information about user behaviour, which allows us to build a specific profile based on your browsing habits and to show you advertising based on that profile. They are used to make advertising messages more relevant to you and your interests."
		},
		analytical: {
			title: "Analytical cookies",
			subtitle: "Optional Cookies",
			description: "These are those which, whether processed by us or by third parties, allow us to quantify the number of users and thus to carry out the measurement and statistical analysis of the use made by users of the service offered. To this end, your browsing on our website is analysed in order to improve the products or services we offer you."
		}
	},
	actions: {
		settings: {
			open: "Cookie preferences",
			close: "Close"
		},
		accept: "Accept all",
		reject: "Reject"
	}
};
var translationUS = {
	cookieConsent: cookieConsent$7
};

var cookieConsent$6 = {
	intro: {
		title: "Tienes que aceptar las cookies para seguir navegando por este sitio",
		body: {
			content: "Usamos cookies para hacer que nuestro sitio funcione y brindar la mejor experiencia. Al hacer clic en Aceptar todas o activar una opción en las Preferencias de cookies, aceptas lo establecido en nuestra {{link}}. Para cambiar tus preferencias o retirar tu consentimiento, actualiza tus Preferencias de cookies.",
			link: {
				href: "https://jobandtalent.com/cookies?locale=es",
				label: "Política de Cookies"
			}
		}
	},
	cookies: {
		technical: {
			title: "Cookies técnicas",
			subtitle: "Cookies strictamente necesarias",
			description: "Esenciales para el correcto funcionamiento del sitio y para la prestación del servicio ofrecido y solicitado por los usuarios.",
			mandatory: {
				title: "Obligatorias",
				description: "Estas cookies son necesarias para el correcto funcionamiento del sitio."
			}
		},
		advertising: {
			title: "Cookies publicitarias",
			subtitle: "Cookies opcionales",
			description: "Almacenan información sobre el comportamiento de los usuarios, lo que nos permite construir un perfil específico en función de sus hábitos de navegación y mostrarle publicidad basada en ese perfil. Se utilizan para hacer que los mensajes publicitarios sean más relevantes para usted y sus intereses."
		},
		analytical: {
			title: "Cookies analíticas",
			subtitle: "Cookies opcionales",
			description: "Son aquellas que, bien tratadas por nosotros o por terceros, nos permiten cuantificar el número de usuarios y así realizar la medición y análisis estadístico de la utilización que hacen los usuarios del servicio ofertado. Para ello, se analiza su navegación en nuestro sitio web con el fin de mejorar los productos o servicios que le ofrecemos."
		}
	},
	actions: {
		settings: {
			open: "Preferencias de cookies",
			close: "Cerrar"
		},
		accept: "Aceptar todas",
		reject: "Rechazar"
	}
};
var translationES = {
	cookieConsent: cookieConsent$6
};

var cookieConsent$5 = {
	intro: {
		title: "Tienes que aceptar las cookies para seguir navegando por este sitio",
		body: {
			content: "Usamos cookies para hacer que nuestro sitio funcione y brindar la mejor experiencia. Al hacer clic en Aceptar todas o activar una opción en las Preferencias de cookies, aceptas lo establecido en nuestra {{link}}. Para cambiar tus preferencias o retirar tu consentimiento, actualiza tus Preferencias de cookies.",
			link: {
				href: "https://jobandtalent.com/cookies?locale=es-CO",
				label: "Política de cookies"
			}
		}
	},
	cookies: {
		technical: {
			title: "Cookies técnicas",
			subtitle: "Cookies strictamente necesarias",
			description: "Esenciales para el correcto funcionamiento del sitio y para la prestación del servicio ofrecido y solicitado por los usuarios.",
			mandatory: {
				title: "Obligatorias",
				description: "Estas cookies son necesarias para el correcto funcionamiento del sitio."
			}
		},
		advertising: {
			title: "Cookies publicitarias",
			subtitle: "Cookies opcionales",
			description: "Almacenan información sobre el comportamiento de los usuarios, lo que nos permite construir un perfil específico en función de sus hábitos de navegación y mostrarle publicidad basada en ese perfil. Se utilizan para hacer que los mensajes publicitarios sean más relevantes para usted y sus intereses."
		},
		analytical: {
			title: "Cookies analíticas",
			subtitle: "Cookies opcionales",
			description: "Son aquellas que, bien tratadas por nosotros o por terceros, nos permiten cuantificar el número de usuarios y así realizar la medición y análisis estadístico de la utilización que hacen los usuarios del servicio ofertado. Para ello, se analiza su navegación en nuestro sitio web con el fin de mejorar los productos o servicios que le ofrecemos."
		}
	},
	actions: {
		settings: {
			open: "Preferencias de cookies",
			close: "Cerrar"
		},
		accept: "Aceptar todas",
		reject: "Rechazar"
	}
};
var translationCO = {
	cookieConsent: cookieConsent$5
};

var cookieConsent$4 = {
	intro: {
		title: "Tienes que aceptar las cookies para seguir navegando por este sitio",
		body: {
			content: "Usamos cookies para hacer que nuestro sitio funcione y brindar la mejor experiencia. Al hacer clic en Aceptar todas o activar una opción en las Preferencias de cookies, aceptas lo establecido en nuestra {{link}}. Para cambiar tus preferencias o retirar tu consentimiento, actualiza tus Preferencias de cookies.",
			link: {
				href: "https://jobandtalent.com/cookies?locale=es-MX",
				label: "Política de cookies"
			}
		}
	},
	cookies: {
		technical: {
			title: "Cookies técnicas",
			subtitle: "Cookies strictamente necesarias",
			description: "Esenciales para el correcto funcionamiento del sitio y para la prestación del servicio ofrecido y solicitado por los usuarios.",
			mandatory: {
				title: "Obligatorias",
				description: "Estas cookies son necesarias para el correcto funcionamiento del sitio."
			}
		},
		advertising: {
			title: "Cookies publicitarias",
			subtitle: "Cookies opcionales",
			description: "Almacenan información sobre el comportamiento de los usuarios, lo que nos permite construir un perfil específico en función de sus hábitos de navegación y mostrarle publicidad basada en ese perfil. Se utilizan para hacer que los mensajes publicitarios sean más relevantes para usted y sus intereses."
		},
		analytical: {
			title: "Cookies analíticas",
			subtitle: "Cookies opcionales",
			description: "Son aquellas que, bien tratadas por nosotros o por terceros, nos permiten cuantificar el número de usuarios y así realizar la medición y análisis estadístico de la utilización que hacen los usuarios del servicio ofertado. Para ello, se analiza su navegación en nuestro sitio web con el fin de mejorar los productos o servicios que le ofrecemos."
		}
	},
	actions: {
		settings: {
			open: "Preferencias de cookies",
			close: "Cerrar"
		},
		accept: "Aceptar todas",
		reject: "Rechazar"
	}
};
var translationMX = {
	cookieConsent: cookieConsent$4
};

var cookieConsent$3 = {
	intro: {
		title: "Du musst die Cookies akzeptieren um weiter auf der Website surfen zu können",
		body: {
			content: "Wir verwenden diese, damit unsere Website funktioniert und damit wir Dir das beste Erlebnis bieten können. Indem Sie auf Alles akzeptieren klicken oder eine Option in den Cookie-Einstellungen aktivieren, akzeptieren Sie, was in unserem {{link}} festgelegt ist. Um Ihre Einstellungen zu ändern oder Ihre Zustimmung zu widerrufen, aktualisieren Sie Ihre Cookie-Einstellungen.",
			link: {
				href: "https://jobandtalent.com/cookies?locale=de",
				label: "Cookie-Richtlinien"
			}
		}
	},
	cookies: {
		technical: {
			title: "Technische Cookies",
			subtitle: "Strikt notwendige Cookies",
			description: "Unverzichtbar für das korrekte Funktionieren der Website und die Bereitstellung der von den Benutzern angebotenen und angeforderten Dienste",
			mandatory: {
				title: "verpflichtend",
				description: "Diese Cookies sind für die korrekte Leistung der Website erforderlich"
			}
		},
		advertising: {
			title: "Werbe-Cookies",
			subtitle: "Optionale Cookies",
			description: "Diese speichern Informationen über das Nutzerverhalten, die es uns ermöglichen, ein spezifisches Profil auf der Grundlage Deiner Surfgewohnheiten zu erstellen und Dir Werbung auf der Grundlage dieses Profils zu zeigen. Sie werden verwendet, um Werbebotschaften relevanter für Dich und Deine Interessen zu machen."
		},
		analytical: {
			title: "Analyse-Cookies",
			subtitle: "Optionale Cookies",
			description: "Diese Cookies, unabhängig davon, ob sie von uns oder von Dritten verarbeitet werden, ermöglichen es uns, die Anzahl der Nutzer zu quantifizieren und somit die Messung und statistische Analyse der Nutzung des angebotenen Dienstes durch die Nutzer durchzuführen. Zu diesem Zweck wird Dein Browsing Verhalten auf unserer Website analysiert, um die Produkte oder Dienstleistungen, die wir Dir anbieten, zu verbessern."
		}
	},
	actions: {
		settings: {
			open: "Cookie-Einstellungen",
			close: "Schließen"
		},
		accept: "Alles akzeptieren",
		reject: "Ablehnen"
	}
};
var translationDE = {
	cookieConsent: cookieConsent$3
};

var cookieConsent$2 = {
	intro: {
		title: "Vous devez accepter les cookies pour continuer à naviguer sur le site",
		body: {
			content: "Nous les utilisons pour faire fonctionner notre site et vous fournir la meilleure expérience. En cliquant sur Accepter tout ou en activant une option dans les Préférences de cookies, vous acceptez ce qui est établi dans notre {{link}}. Pour modifier vos préférences ou retirer votre consentement, mettez à jour vos préférences en matière de cookies.",
			link: {
				href: "https://jobandtalent.com/cookies?locale=fr",
				label: "Politique en matière de cookies"
			}
		}
	},
	cookies: {
		technical: {
			title: "Cookies techniques",
			subtitle: "Cookies strictement nécéssaires",
			description: "Indispensable pour le bon fonctionnement du site et pour fournir le service offert et demandé par les utilisateurs.",
			mandatory: {
				title: "Oligatoire",
				description: "Ces cookies sont nécesaires pour le bon fonctionnement du site"
			}
		},
		advertising: {
			title: "Cookies publicitaires",
			subtitle: "Cookies optionnels",
			description: "Ils stockent l'information sur le comportement des utilisateurs, ce quis nous permet de construire un profil spécifique en fonction de vos habitudes de navigation et de vous montrer des publicités basées sur ce profil. Ils sont utilisés pour rendre les messages publiciaires plus pertinents pour vous et vos intérêts."
		},
		analytical: {
			title: "Cookies analytiques",
			subtitle: "Cookies optionnels",
			description: "Ces cookies, sont ceux qui traités par nous ou d'autres parties, nous permettent de quantifier le nombre d'utilisateurs et donc d'effectuer la mesure et l'analyse statistique de l'utilisation par les utilisateurs du service offert. Pour cela, votre navigation sur notre site web est analysée afin d'améliorer les produits ou services que nous proposons."
		}
	},
	actions: {
		settings: {
			open: "Préférences en matière de cookies",
			close: "Fermer"
		},
		accept: "Accepter tout",
		reject: "Rejeter"
	}
};
var translationFR = {
	cookieConsent: cookieConsent$2
};

var cookieConsent$1 = {
	intro: {
		title: "Necessita aceitar a nossa política de cookies para continuar visitar o nosso website",
		body: {
			content: "Utilizamo-los para fazer o nosso site funcionar e proporcionar a melhor experiência. Ao clicar em Aceitar tudo ou ativar uma opção nas Preferências de Cookies, você aceita o que está estabelecido em nosso {{link}}. Para alterar suas preferências ou retirar seu consentimento, atualize suas Preferências de cookie.",
			link: {
				href: "https://jobandtalent.com/cookies?locale=pt",
				label: "Política de Cookies"
			}
		}
	},
	cookies: {
		technical: {
			title: "Cookies técnicos",
			subtitle: "Cookies estritamente necessários",
			description: "Essencial para o correto funcionamento do site e para a prestação do serviço oferecido e solicitado pelos usuários.",
			mandatory: {
				title: "Obrigatório",
				description: "Estes cookies são necessários para um desempenho óptimo do nosso website"
			}
		},
		advertising: {
			title: "Cookies publicitários",
			subtitle: "Cookies opcionais",
			description: "Armazenam informação sobre o comportamento do utilizador, o que nos permite construir um perfil específico baseado nos seus hábitos de navegação e mostrar-lhe publicidade com base nesse perfil. São utilizados para tornar as mensagens publicitárias mais relevantes para si e para os seus interesses."
		},
		analytical: {
			title: "Cookies analíticos",
			subtitle: "Cookies opcionais",
			description: "Estes são aqueles que, quer processados por nós ou por terceiros, nos permitem quantificar o número de utilizadores e assim realizar a medição e análise estatística da utilização feita pelos utilizadores do serviço oferecido. Para o efeito, a sua navegação no nosso website é analisada a fim de melhorar os produtos ou serviços que lhe oferecemos."
		}
	},
	actions: {
		settings: {
			open: "Preferências de Cookies",
			close: "Fechar"
		},
		accept: "Aceitar tudo",
		reject: "Rejeitar"
	}
};
var translationPT = {
	cookieConsent: cookieConsent$1
};

var cookieConsent = {
};
var translationSE = {
	cookieConsent: cookieConsent
};

var resources = {
  en: {
    translation: translationEN
  },
  es: {
    translation: translationES
  },
  'en-US': {
    translation: translationUS
  },
  'en-GB': {
    translation: translationEN
  },
  'es-ES': {
    translation: translationES
  },
  'es-CO': {
    translation: translationCO
  },
  'es-MX': {
    translation: translationMX
  },
  de: {
    translation: translationDE
  },
  fr: {
    translation: translationFR
  },
  pt: {
    translation: translationPT
  },
  sv: {
    translation: translationSE
  }
};
i18next.use(Browser).use(initReactI18next).init({
  resources: resources,
  nonExplicitSupportedLngs: true,
  fallbackLng: 'en',
  detection: {
    order: ['navigator', 'htmlTag', 'localStorage']
  },
  interpolation: {
    escapeValue: false // not needed for react as it escapes by default

  }
}).then(function (translator) {
});

var eventBus = {
  on: function on(event, callback) {
    document.addEventListener(event, callback);
  },
  dispatch: function dispatch(event, data) {
    document.dispatchEvent(new CustomEvent(event, {
      detail: data
    }));
  },
  off: function off(event, callback) {
    document.removeEventListener(event, callback);
  }
};

var styles$6 = {"overlay":"Overlay__overlay__RKnWo"};

var Component$7 = function Component() {
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "modal-overlay",
    className: styles$6.overlay
  });
};

var js_cookie = {exports: {}};

/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */

(function (module, exports) {
(function (factory) {
	var registeredInModuleLoader;
	{
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));
}(js_cookie));

var CookiesManager = js_cookie.exports;

var img = "data:image/svg+xml,%3csvg width='48' height='49' viewBox='0 0 48 49' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3cdefs%3e%3cpath d='M25.042 1.145c0 .72-1.643 2.133.94 2.996 2.582.862 4.55-.158 4.55-.737S27.248.384 27.248.384s-2.205.04-2.205.76z' id='a'/%3e%3cpath d='M1.867 21.386c-.827-.445-1.77-2.14-1.77-2.14 2.778-.405 6.564-1.397 4.536 2.446 0 0-2.08.064-2.766-.306z' id='b'/%3e%3cpath d='M17.3 15.35c-3.253 3.021 2.158 8.096 3.973 3.133l-3.974-3.134z' id='c'/%3e%3cpath d='M12.05 31.759c1.59 2.618-2.882 6.524-3.8 4.118-.92-2.406-.479-4.059.955-4.626 1.433-.567 1.254-2.11 2.845.508z' id='d'/%3e%3cpath d='M25.12 30.18c2.641-1.165 4.883.366 4.883.366s-1.06 3.22-2.971 3.22-2.725-1.807-2.725-1.807-1.827-.614.814-1.78z' id='e'/%3e%3c/defs%3e%3cg fill='none' fill-rule='evenodd'%3e%3cpath d='M3.126 15.503c1.28 1.15 3.302 2.448 5.187 1.705 1.884-.743 5.039-1.335 5.039-1.335s3.675-2.58 4.336-3.878c.661-1.3 1.99-7.087 1.99-7.087s-.405-3.709-2.08-1.854c-1.674 1.854-3.942 5.436-4.603 6.18-.662.746-3.05 4.096-3.56 4.096-.508 0-7.59 1.024-6.309 2.173zM9.53 37.84c-.587 0-4.346-4.732-3.002-6.732 1.345-2 5.182-1.612 7.691-2.116 2.51-.504.115-1.303 2.762-2.642s4.827.23 6.633.648c1.806.417 2.541 2.265 5.418 1.568 2.876-.696 2.9-3.702 2.9-5.311 0-1.61.365-2.832 1.43-2.832 1.067 0 .91-.83 2.054-1.72 1.144-.89 2.71.264 3.698-.791.986-1.055.286-2.237.286-3.328 0-1.09-.048-3.512 1.48-2.61 1.528.902 4.677 13.811 4.677 13.811l-3.191 8.449-6.956 7.642-5.286 3.48-9.685-.09s-6.903-2.37-8.152-4.052c-1.25-1.68-2.168-3.374-2.756-3.374z' fill='%23CEBA8F' opacity='.5'/%3e%3cg transform='translate(7 4)'%3e%3cuse fill='white' xlink:href='%23a'/%3e%3cuse fill-opacity='.4' fill='%234B5966' xlink:href='%23a'/%3e%3c/g%3e%3cg transform='translate(7 4)'%3e%3cuse fill='white' xlink:href='%23b'/%3e%3cuse fill-opacity='.4' fill='%234B5966' xlink:href='%23b'/%3e%3c/g%3e%3cg transform='translate(7 4)'%3e%3cuse fill='white' xlink:href='%23c'/%3e%3cuse fill-opacity='.4' fill='%234B5966' xlink:href='%23c'/%3e%3c/g%3e%3cg transform='translate(7 4)'%3e%3cuse fill='white' xlink:href='%23d'/%3e%3cuse fill-opacity='.4' fill='%234B5966' xlink:href='%23d'/%3e%3c/g%3e%3cg transform='translate(7 4)'%3e%3cuse fill='white' xlink:href='%23e'/%3e%3cuse fill-opacity='.4' fill='%234B5966' xlink:href='%23e'/%3e%3c/g%3e%3cpath d='M25.78 10.65s-3.064-.725-2.105 1.158c.96 1.882 4.96 4.984 4.96 3.583 0-1.402-.004-3.355-.723-4.048-.72-.693-2.132-.693-2.132-.693zM7.03 7.296c1.218.849 2.973 2.307 1.68 2.98-1.294.674-2.998 1.438-3.835.857-.837-.581-1.793-1.325-1.108-2.244.685-.92 2.045-2.441 3.263-1.593zM6.465 2.828c1.284.602 1.677 1.218 2.053.437.375-.782.782-1.436.142-1.985C8.02.731 7.594.26 7.03.77c-.565.51-1.848 1.455-.565 2.058z' fill='%23CEBA8F' opacity='.5'/%3e%3cg fill='%234B5966'%3e%3cpath d='M41.28 12.134c.783 1.441 1.122 2.706 1.408 3.75.271 1.055.437 1.933.607 2.822.086.447.167.891.278 1.381.044.227.136.537.186.748.062.226.115.466.163.721.192 1.02.306 2.288.26 3.966a23.884 23.884 0 01-.172 2.255c-.085.65-.182 1.319-.326 1.697-.376.967-.863 1.82-1.333 2.639-.985 1.623-1.998 3.31-4.095 5.95-.268.32-.52.6-.75.831-.168.162-.483.394-.738.588l-1.328 1.023-1.884 1.439c-.563.415-1.131.832-1.927 1.322-.396.243-.858.51-1.388.726-.49.206-1.176.311-2 .36-1.671.079-2.934-.057-4.003-.108-.297-.004-.476-.044-.914.014-.175.033-.39.05-.597.065-.418.028-.823.04-1.226.05-.806.014-1.622.015-2.647-.019-.867.018-2.018-.444-3.593-1.118-.702-.306-1.76-.788-2.338-1.093 0 0-1.028-.493-2.106-.922-.39-.135-.87-.49-1.238-.698-.373-.218-.67-.334-.806-.207-.134.126-.044.436.196.827.257.385.594.872 1.248 1.277a29.174 29.174 0 002.015 1.137l2.07.976c.804.359 1.514.656 2.177.891.671.23 1.25.425 1.966.477a42.953 42.953 0 004.1-.043c.23-.014.468-.033.74-.066.394-.059.34-.058.63-.053 1 .026 2.318.171 4.117.119.909-.04 1.724-.132 2.494-.384.752-.261 1.282-.58 1.777-.864a30.703 30.703 0 002.397-1.612c.71-.52 1.405-1.053 2.266-1.714l.678-.52.367-.279.191-.143.234-.202c.587-.541 1.052-1.132 1.606-1.833 2.112-2.81 2.902-4.153 3.734-5.493.395-.689.8-1.356 1.24-2.349.105-.258.222-.517.312-.873.1-.346.132-.625.193-.972a24.05 24.05 0 00.245-2.326c.1-1.779.01-3.172-.169-4.366a12.764 12.764 0 00-.376-1.664c-.13-.437-.233-.889-.337-1.347-.207-.922-.405-1.865-.702-2.996-.306-1.127-.672-2.463-1.484-4.106-.447-.88-.964-1.607-1.582-2.177a9.916 9.916 0 00-1.553-1.115c-.88-.508-1.408-.648-1.455-.453-.044.172.296.61.931 1.266.313.329.712.714 1.12 1.155.38.404.749.992 1.121 1.643M4.337 33.5c-.83-1.232-1.434-2.22-1.797-3.019a11.573 11.573 0 01-.948-4.646c.006-.453.042-.908.14-1.475.102-.633.17-1.325.179-2.128.002-.401-.012-.784-.047-1.156a8.158 8.158 0 00-.072-.547c-.005-.075-.015-.141 0-.215.023-.3.335-.707.605-1.327.063-.166.124-.344.15-.553.038-.18.007-.504.015-.482-.001-.11.023-.257.072-.406.101-.3.272-.606.482-.865.201-.257.466-.488.681-.584l1.277-.528c.455-.184.921-.359 1.454-.48a7.89 7.89 0 01.862-.15l.51-.054a4.673 4.673 0 003.328-1.958l.382-.54c.48-.666.848-1.146 1.226-1.616.381-.469.771-.931 1.34-1.522l.466-.467c.188-.18.415-.42.605-.711a3.11 3.11 0 00.263-.494c.069-.164.107-.262.177-.408.128-.271.281-.566.466-.874.74-1.236 1.45-2.052 2.072-2.54a3.36 3.36 0 01.447-.296c.152-.085.349-.18.51-.26.335-.168.643-.311.938-.425.61-.23.996-.27 1.816-.016.199.06.418.136.648.219.234.083.535.19.836.27.613.171 1.309.277 2.083.358.695.07 1.71.125 2.26.205l1.932.159c.887.079 1.875.351 2.027.008.15-.324-.665-.976-1.757-1.322a13.07 13.07 0 00-2.038-.41l-1.968-.177c-.734-.068-1.344-.149-1.859-.27-.516-.113-.917-.278-1.411-.44-.464-.15-.922-.278-1.424-.316a3.572 3.572 0 00-1.413.198c-.412.14-.764.31-1.127.488-.355.188-.715.337-1.21.68-.883.649-1.673 1.56-2.515 2.91-.209.34-.392.664-.551.986-.158.295-.316.719-.377.824-.093.17-.22.33-.363.475l-.53.522A26.68 26.68 0 0011.494 10c-.488.601-.96 1.216-1.513 2.005-.445.621-1.178 1.272-2.5 1.365-1.61.139-2.749.661-3.536.978l-.57.227a4.548 4.548 0 00-.33.142 3.15 3.15 0 00-.321.19 4.12 4.12 0 00-.918.876c-.245.318-.455.661-.622 1.081a3.376 3.376 0 00-.198.71c-.016.14-.036.278-.027.439l.003.119c0 .03-.002.02-.002.031.001.012.002.027-.004.046.003.15-.244.51-.552 1.154-.143.322-.28.78-.223 1.285l.066.508c.016.155.029.32.036.493a12.99 12.99 0 01-.066 1.898c-.03.294-.067.523-.109.82a9.073 9.073 0 00-.084.849 11.221 11.221 0 00.222 2.828c.174.861.425 1.704.832 2.676.429 1.013 1.073 2.015 1.91 3.285 1.827 2.705 3.376 3.94 3.572 3.605.187-.3-.664-1.822-2.224-4.111'/%3e%3cpath d='M18.519 6.012c-.022.352.019.719.045.94.025.236.04.435.038.598-.003.322-.07.536-.165.81-.21.584-.401 1.02-1.041 2.06a28.002 28.002 0 01-1.421 2.115c-.2.27-.405.535-.655.84-.238.283-.58.681-.892.918-.374.244-.751.373-1.036.47-.29.097-.516.164-.745.225-.23.06-.464.116-.79.168-.164.025-.35.05-.575.074-.107.01-.229.02-.429.051-.17.034-.342.079-.511.137-.669.235-1.068.45-1.414.6-.34.157-.599.268-.853.366a7.027 7.027 0 01-.382.134 1.403 1.403 0 01-.336.06c-.272.024-.66.004-1.203-.111-.243-.053-.62-.134-.823-.226 0 0-.365-.105-.767-.159-.402-.045-.846-.042-1.003.298-.153.331.143.694.507.948.359.261.777.41.777.41.228.064.554.17.845.238.665.152 1.2.2 1.678.168.24-.016.463-.05.688-.116.223-.07.345-.122.506-.187.591-.23 1.17-.58 2.174-.981.12-.042.23-.077.316-.096.098-.023.123-.023.274-.038l.664-.075c.401-.055.725-.115 1.05-.19.324-.076.65-.161 1.059-.303.402-.157.917-.316 1.531-.85.52-.488.801-.84 1.047-1.13l.593-.734c.349-.45.698-.893 1.374-1.966.334-.54.576-.974.771-1.38.094-.19.19-.428.252-.61l.164-.522c.1-.347.208-.766.207-1.287.01-.49-.127-1.054-.123-1.49.012-1.013.173-1.741-.165-1.944-.142-.074-.4-.003-.667.285-.264.282-.53.798-.564 1.482M7.827 23.801a3.35 3.35 0 00.387-.356l.398-.386c.09-.066.143-.147.47-.12.336.035.557.136.755.214.1.042.208.082.342.121l.245.094c.114.061.157.06.255.131.084.07.18.185.205.537.01.181-.007.33-.032.47-.023.19-.055.181-.092.19a.193.193 0 01-.104 0c-.046.002-.004-.05-.077.002l-.42.264c-.113.066-.26.143-.478.085-.237-.073-.416-.203-.549-.298-.139-.112-.286-.218-.56-.449-.273-.233-.371-.343-.479-.445-.039-.049-.1-.105-.13-.16a.292.292 0 01-.046-.078c-.002-.008-.02-.03-.01-.02-.001.012-.17.025-.215.021a.202.202 0 01-.11-.013s.025.013.02.017l-.998-.798c-.12.177-.252.429-.262.656-.026.547.136.769.213.94.093.176.173.28.252.389.163.203.324.398.689.713.367.312.596.403.818.498.241.083.425.182.956.359.568.155.85.16 1.144.2.29.015.602.038 1.14-.275.124-.077.265-.182.382-.302.115-.114.2-.229.264-.337.13-.217.175-.418.188-.613-.008-.1 0-.196-.02-.299l-.023-.158-.017-.076a4.293 4.293 0 01-.043-.516c-.029-.487-.075-.787-.172-1.09-.104-.281-.262-.693-.895-1.048a1.975 1.975 0 00-.73-.203c-.142-.008-.227.004-.335.008-.211.012-.404.01-.88-.052a4.008 4.008 0 00-1.028.003c-.242.037-.53.114-.95.465-.311.266-.562.601-.69.738l1.222.977zM23.77 20.89l.489-.26c.29-.132.388-.158.55-.188.159-.02.348-.025.77.138.427.172.671.337.735.433.095.126.167.226.322.498.146.288.228.478.31.663.08.19.157.401.137.833-.03.474-.151.528-.248.544-.114.013-.1-.051-.261-.026-.198.014-.412-.006-.592-.017a1.569 1.569 0 01-.748-.292 2.932 2.932 0 01-.617-.58 7.697 7.697 0 01-.496-.68c-.213-.345-.28-.503-.333-.642-.056-.125-.092-.324-.043-.373-.004-.017.018-.02.03-.045l-.993-1.22c-.11.122-.28.255-.371.428-.264.426-.255.766-.265 1.006.013.234.037.42.083.572.082.324.195.612.5 1.12.321.49.546.674.77.85l.9.679c.474.328.7.503.953.687.266.16.525.39 1.31.385.818-.05 1.272-.495 1.48-.86.228-.364.312-.877.336-1.393.031-.57.022-.859.009-1.157-.028-.297-.028-.608-.316-1.21-.31-.6-.655-.827-.957-.988-.147-.087-.335-.147-.504-.212a8.158 8.158 0 01-.573-.215 15.4 15.4 0 00-.972-.37c-.236-.056-.547-.189-1.245.022-.527.168-.949.524-1.137.655l.987 1.215zM16.174 36.514c.159-.043.33-.106.583-.195.383-.117.56-.135.75-.165.186-.023.392-.035.728.145.461.299.476.553.552.839-.026.024-.011.008-.04.152-.05.271-.14.52-.208.721-.076.21-.164.439-.484.79-.326.343-.56.44-.774.506-.223.067-.406.115-.674.178a3.76 3.76 0 01-.6.067.628.628 0 01-.528-.237.623.623 0 01-.133-.294 3.786 3.786 0 01-.049-.364c-.02-.242-.059-.495-.038-.863.03-.352.102-.453.162-.598.076-.13.16-.272.5-.516.072-.049.145-.094.256-.16l-.763-1.374c-.09.064-.215.13-.323.195-.535.361-.774.641-.977.932a2.754 2.754 0 00-.476 1.36c-.042.698.087.966.163 1.244l.148.454c.064.223.178.49.395.794.465.587.8.763 1.115.969.323.169.707.368 1.467.242.763-.162 1.037-.463 1.268-.664l.846-.874c.403-.432.587-.67.78-.911.178-.259.392-.482.585-1.208a1.751 1.751 0 00-.084-1.081c-.16-.35-.327-.53-.517-.741a4.477 4.477 0 00-.824-.664c-.587-.344-.86-.39-1.112-.488-.254-.055-.545-.164-1.21-.033-.508.093-1.018.369-1.244.474l.76 1.368zM33.012 34.575c.154-.041.322-.1.564-.192.362-.122.513-.153.678-.187.165-.025.332-.052.669.111.34.184.496.38.654.557l.26.285c.002.012.005.02.01.027 0 0 .006.016.012 0a.525.525 0 01.167-.118c.034-.014.022-.014.04-.022a.15.15 0 01.044-.012.117.117 0 01-.04.004c.005-.004-.105-.002-.17-.026-.02-.007-.08-.034-.097-.033l-.003.01c.013.008-.026.06-.027.09-.041.083-.08.166-.134.253-.108.174-.239.36-.614.646-.76.546-1.01.439-1.597.72-.273.093-.308.12-.43.15-.113.018-.271.026-.59-.224-.356-.29-.392-.39-.446-.512-.034-.12-.07-.2-.024-.397.06-.213.164-.357.257-.483.108-.125.212-.267.566-.491l.255-.15-.746-1.384c-.082.056-.197.113-.295.171a4.65 4.65 0 00-.925.731c-.193.242-.453.45-.686 1.18-.18.775.062 1.205.245 1.5.191.295.491.573.895.896.435.353.72.57 1.058.74.33.163.822.288 1.495.046.626-.259.809-.48 1.018-.675.178-.187.343-.361.755-.67l.862-.654c.115-.1.23-.193.37-.36.125-.18.345-.368.426-.964a1.413 1.413 0 00-.183-.791 1.411 1.411 0 00-.342-.39c-.05-.04-.113-.09-.148-.111l-.086-.049-.167-.088c-.23-.114-.442-.254-.955-.549-.54-.277-.808-.35-1.054-.422-.245-.058-.538-.14-1.155.007-.466.11-.92.36-1.128.452l.742 1.378zM32.91 5.47c.528-.361.699-.257 1.05-.179.177.047.34.101.492.175.153.075.283.158.603.407.318.247.613.457.858.614l.179.113.1.07c.065.036.091.08.137.114.098.158.211.216.029.701-.101.225-.248.393-.27.419a.528.528 0 01-.203.135c-.195.077-.467.167-1.163.043-.7-.15-1.01-.324-1.305-.482-.279-.166-.626-.346-1.042-.76-.098-.093-.184-.213-.19-.271.002-.011-.046-.057-.128-.135-.1-.085-.145-.373-.429-.61-.268-.234-.687-.093-.89.375-.101.229-.103.484-.084.668.031.172.07.284.07.284.1.225.26.497.42.675.365.405.658.6.898.76.242.155.437.26.633.36.398.184.793.385 1.689.585.909.177 1.427.118 1.967-.035.257-.08.6-.237.885-.537.25-.275.475-.583.658-1.104.18-.518.152-1.003.047-1.36a2.073 2.073 0 00-.454-.809c-.092-.09-.185-.201-.292-.274a5.971 5.971 0 00-.314-.226c-.182-.12-.392-.266-.696-.499-.297-.23-.627-.479-.97-.626a3.461 3.461 0 00-.87-.24c-.24-.031-.524-.08-.917-.037a2.69 2.69 0 00-1.248.503c-.869.67-.784 1.388-.487 1.569.281.18.777-.021 1.238-.385M5.976 8.026l.048-.013c.117-.034.22-.051.274-.05.06.003.048.001.08.019 0 0 .043.001.331.308.08.081.125.137.263.265.132.129.303.241.462.328l.318.155c.007.004.004.008.007.011-.007-.039.038.173.039.377l.002.155c-.006.026-.011.042-.013.062.009.045-.027.066-.026.1-.047.114-.186.207-.186.207-.22.175-.501.268-.705.328-.209.064-.378.095-.544.119-.169.027-.34.035-.565.016-.202-.016-.543-.108-.717-.25-.152-.157-.202-.387-.19-.593.015-.204.058-.377.132-.537.065-.161.16-.314.29-.487.131-.17.32-.364.591-.475l.067-.028.03-.014-.473-1.534-.077.03-.022.008c-.7.263-1.064.66-1.32.975a3.45 3.45 0 00-.728 1.958c0 .411.008 1.039.6 1.698.138.16.319.27.464.366.14.067.277.145.4.184.252.094.47.138.667.175a4.546 4.546 0 001.99-.174c.365-.128.841-.272 1.364-.827.55-.554.532-1.374.515-1.614a3.812 3.812 0 00-.051-.522 1.808 1.808 0 00-.226-.594c-.188-.386-.794-.64-.882-.692-.087-.055-.082-.05-.195-.165-.132-.131-.259-.29-.548-.53-.212-.184-.61-.387-.97-.404a2.45 2.45 0 00-.876.1l-.105.028.485 1.531zM7.008 2.246l-.005-.019a.286.286 0 01-.022-.158s.008-.05.057-.145a.79.79 0 01.303-.303.45.45 0 01.286-.07l-.002.005a.723.723 0 01.116.183c.048.098.088.19.126.285.037.09.075.213.102.34.016.02.042.074-.004.115-.02.053-.365.075-.507.024-.161-.036-.37-.131-.432-.233l-.008-.01-.009-.009-1.436.718.054.091.01.015c.298.485.666.675.925.79.269.107.48.15.688.175A2.719 2.719 0 008.4 3.92c.217-.08.464-.19.67-.398.453-.4.445-.908.398-1.263a4.362 4.362 0 00-.12-.585 3.908 3.908 0 00-.214-.604A2.378 2.378 0 008.887.65a1.662 1.662 0 00-.56-.477C7.787-.073 7.4.001 7.14.05a2.34 2.34 0 00-1.174.639c-.18.193-.401.456-.53.946-.099.375-.08.82.08 1.198l.057.136.715-.367.72-.356M27.704 10.741c-.378-.246-.493-.492-1.374-.731-.34-.063-.4-.14-.858-.148-.29-.015-1.054-.03-1.297.049 0 0-.15.022-.283.12-.134.097-.247.27-.168.537.157.523.617.473.617.473.16.011.413-.077 1.027-.064.186.012.384.01.652.092.415.131.793.329 1.038.502.481.333 1.043.543 1.249.357.177-.167-.011-.76-.603-1.187M39.271 21.104c-.554.087-.841.083-1.837.11-.375-.013-.422-.064-.867-.197a1.867 1.867 0 01-.578-.38c-.203-.188-.372-.415-.467-.525 0 0-.1-.14-.26-.262a.862.862 0 00-.299-.155c-.11-.029-.287-.04-.345.092-.062.133-.144.194-.177.29a.542.542 0 00-.015.299c.04.207.156.387.156.387a2.6 2.6 0 00.395.492c.213.21.531.502 1.087.764.343.15.746.253 1.304.297.85.06 1.538-.078 2.037-.168.985-.18 1.721-.77 1.587-1.02-.11-.218-.844-.191-1.72-.024M18.119 27.252c-.18-.032-.226-.115-.557-.205-.129-.047-.12-.104-.289-.195-.114-.056-.299-.357-.385-.436 0 0-.158-.226-.622.073-.468.303-.286.62-.286.62.056.112.173.26.558.586.123.1.263.185.486.315.348.198.705.254.957.285.529.055.873-.363.77-.617-.085-.234-.374-.398-.632-.426M24.202 37.374c-.014.215-.088.292-.175.718-.04.159-.1.168-.178.345-.056.13-.306.238-.41.293 0 0-.062.024-.128.117-.062.093-.128.264-.02.52.107.255.225.37.34.414.116.045.23.01.23.01.133-.04.456-.132.873-.67a3.04 3.04 0 00.318-.62c.169-.406.202-.808.2-1.104a.944.944 0 00-.301-.71c-.17-.147-.364-.166-.468-.072-.184.157-.28.45-.281.76'/%3e%3c/g%3e%3cpath d='M17.759 35.463l-.567-.208.567.208z' stroke='%23979797'/%3e%3cpath d='M10.879 42.704s5.732 4.795 8.746 4.795c3.013 0 4.997.55 6.299.55 1.302 0 8.908-1.424 10.918-2.507 2.01-1.083 6.231-5.516 7.265-7.492 1.035-1.976 3.56-9.35 3.56-10.984 0-1.634-1.082-8.09-1.638-8.858-.557-.768-2.273-2.205-2.273-2.205l1.349 9.933-3.129 8.606-8.693 8.54-5.9 2.133-7.596-.094-8.908-2.417z' fill='%234B5966' opacity='.1'/%3e%3c/g%3e%3c/svg%3e";

var styles$5 = {"container":"Intro__container__35h3p","image":"Intro__image__35h3p","header":"Intro__header__35h3p","body":"Intro__body__35h3p"};

/* eslint-disable react/no-danger */

var Component$6 = function Component() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/React.createElement("div", {
    className: styles$5.container
  }, /*#__PURE__*/React.createElement("img", {
    className: styles$5.image,
    src: img,
    alt: "Yummy!"
  }), /*#__PURE__*/React.createElement("h1", {
    className: styles$5.header
  }, t('cookieConsent.intro.title')), /*#__PURE__*/React.createElement("p", {
    className: styles$5.body,
    dangerouslySetInnerHTML: {
      __html: t('cookieConsent.intro.body.content', {
        link: "<a href=\"".concat(t('cookieConsent.intro.body.link.href'), "\" target=\"_blank\">\n              ").concat(t('cookieConsent.intro.body.link.label'), "\n            </a>"),
        interpolation: {
          escapeValue: false
        }
      })
    }
  }));
};

var SAME_SITE_OPTIONS = {
  STRICT: 'strict',
  LAX: 'lax',
  NONE: 'none'
};
var COOKIE_OPTIONS = {
  expires: 365,
  sameSite: SAME_SITE_OPTIONS.LAX
};
var CONFIG = {
  COOKIES: {
    TECHNICAL: 'technical',
    ADVERTISING: 'advertising',
    ANALYTICAL: 'analytical'
  },
  COOKIE: {
    CONSENT: 'jt_cookie_consent'
  },
  EVENT: {
    COOKIES_CONSENT: 'onCookiesConsent'
  }
};

var styles$4 = {"container":"Expandible__container__3v_TT","actionable":"Expandible__actionable__3v_TT","right":"Expandible__right__3v_TT","button":"Expandible__button__3v_TT","icon":"Expandible__icon__3v_TT","reverse":"Expandible__reverse__3v_TT","cookie":"Expandible__cookie__3v_TT","title":"Expandible__title__3v_TT","subtitle":"Expandible__subtitle__3v_TT","content":"Expandible__content__3v_TT"};

var Component$5 = function Component(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      action = _ref.action,
      content = _ref.content;

  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var toggleHandle = function toggleHandle() {
    return setExpanded(!expanded);
  };

  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "expandible",
    className: styles$4.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$4.actionable
  }, /*#__PURE__*/React.createElement("button", {
    "data-testid": "expandible-toggle",
    type: "button",
    className: styles$4.button,
    onClick: toggleHandle
  }, /*#__PURE__*/React.createElement(IconSvg, {
    icon: "chevron-down",
    className: cx(styles$4.icon, _defineProperty$1({}, styles$4.reverse, expanded))
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$4.cookie
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$4.title
  }, title), /*#__PURE__*/React.createElement("div", {
    className: styles$4.subtitle
  }, subtitle))), /*#__PURE__*/React.createElement("div", {
    "data-testid": "expandible-action",
    className: styles$4.right
  }, action)), expanded && /*#__PURE__*/React.createElement("div", {
    className: styles$4.content
  }, content));
};

Component$5.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  content: PropTypes.string,
  action: PropTypes.node
};
Component$5.defaultProps = {
  title: 'Technical Cookies',
  subtitle: 'Strictly necessary cookies',
  content: 'They store information about user behaviour, which allows us to build a specific profile based on your browsing habits and to show you advertising based on that profile. They are used to make advertising messages more relevant to you and your interests.',
  action: null
};

var styles$3 = {"container":"Mandatory__container__xWAYD","content":"Mandatory__content__xWAYD","icon":"Mandatory__icon__xWAYD"};

var Component$4 = function Component() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/React.createElement("div", {
    className: styles$3.container
  }, /*#__PURE__*/React.createElement(Tooltip, {
    tooltipInfo: t('cookieConsent.cookies.technical.mandatory.description')
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$3.content
  }, t('cookieConsent.cookies.technical.mandatory.title'), ' ', /*#__PURE__*/React.createElement(IconSvg, {
    className: styles$3.icon,
    icon: "info"
  }))));
};

var Component$3 = function Component(_ref) {
  var _onChange = _ref.onChange,
      cookies = _ref.cookies;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Component$5, {
    title: t('cookieConsent.cookies.technical.title'),
    subtitle: t('cookieConsent.cookies.technical.subtitle'),
    action: /*#__PURE__*/React.createElement(Component$4, null),
    content: t('cookieConsent.cookies.technical.description')
  }), /*#__PURE__*/React.createElement(Component$5, {
    title: t('cookieConsent.cookies.advertising.title'),
    subtitle: t('cookieConsent.cookies.advertising.subtitle'),
    action: /*#__PURE__*/React.createElement(Switch, {
      id: CONFIG.COOKIES.ADVERTISING,
      name: CONFIG.COOKIES.ADVERTISING,
      checked: cookies.indexOf(CONFIG.COOKIES.ADVERTISING) >= 0,
      onChange: function onChange(checked) {
        return _onChange({
          cookie: CONFIG.COOKIES.ADVERTISING,
          active: checked
        });
      }
    }),
    content: t('cookieConsent.cookies.advertising.description')
  }), /*#__PURE__*/React.createElement(Component$5, {
    title: t('cookieConsent.cookies.analytical.title'),
    subtitle: t('cookieConsent.cookies.analytical.subtitle'),
    action: /*#__PURE__*/React.createElement(Switch, {
      checked: cookies.indexOf(CONFIG.COOKIES.ANALYTICAL) >= 0,
      id: CONFIG.COOKIES.ANALYTICAL,
      name: CONFIG.COOKIES.ANALYTICAL,
      onChange: function onChange(checked) {
        return _onChange({
          cookie: CONFIG.COOKIES.ANALYTICAL,
          active: checked
        });
      }
    }),
    content: t('cookieConsent.cookies.analytical.description')
  }));
};

Component$3.propTypes = {
  onChange: PropTypes.func,
  cookies: PropTypes.arrayOf(PropTypes.string)
};
Component$3.defaultProps = {
  onChange: function onChange() {},
  cookies: []
};

var styles$2 = {"container":"Actions__container__QVQFy","open":"Actions__open__QVQFy","actions":"Actions__actions__QVQFy","button":"Actions__button__QVQFy"};

var noop = function noop() {};

var Component$2 = function Component(_ref) {
  var settings = _ref.settings,
      onSettings = _ref.onSettings,
      onAccept = _ref.onAccept,
      onReject = _ref.onReject;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles$2.container, _defineProperty$1({}, styles$2.open, settings))
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$2.settings
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: styles$2.button,
    onClick: onSettings
  }, settings ? t('cookieConsent.actions.settings.close') : t('cookieConsent.actions.settings.open'))), /*#__PURE__*/React.createElement("ul", {
    className: styles$2.actions
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Button, {
    small: true,
    secondary: true,
    onSelect: onReject
  }, t('cookieConsent.actions.reject'))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Button, {
    small: true,
    primary: true,
    onSelect: onAccept
  }, t('cookieConsent.actions.accept')))));
};

Component$2.propTypes = {
  settings: PropTypes.bool,
  onSettings: PropTypes.func,
  onAccept: PropTypes.func,
  onReject: PropTypes.func
};
Component$2.defaultProps = {
  settings: false,
  onSettings: noop,
  onAccept: noop,
  onReject: noop
};

var styles$1 = {"modal":"Modal__modal__3TaI1"};

var ACTIONS = {
  COOKIE: 'COOKIE',
  SETTINGS: 'SETTINGS'
};
var initialState = {
  cookies: [CONFIG.COOKIES.ADVERTISING, CONFIG.COOKIES.ANALYTICAL],
  settings: false
};

var reducer = function reducer(state, action) {
  switch (action.type) {
    case ACTIONS.COOKIE:
      {
        var cookies = action.payload.active ? [].concat(_toConsumableArray(state.cookies), [action.payload.cookie]) : state.cookies.filter(function (c) {
          return c !== action.payload.cookie;
        });
        return _objectSpread2(_objectSpread2({}, state), {}, {
          cookies: cookies
        });
      }

    case ACTIONS.SETTINGS:
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          settings: !state.settings
        });
      }

    default:
      return state;
  }
};

var setCookie = function setCookie(cookie, cookieValue) {
  var _ref = typeof window !== 'undefined' ? window : {},
      location = _ref.location;

  var cookieSecurity = location ? location.protocol === 'https:' : true;
  var cookieOptions = {
    expires: COOKIE_OPTIONS.expires,
    sameSite: COOKIE_OPTIONS.sameSite,
    secure: cookieSecurity
  }; // set the regular cookie

  CookiesManager.set(cookie, cookieValue, cookieOptions);
};

var Component$1 = function Component() {
  var _useReducer = useReducer(reducer, initialState),
      _useReducer2 = _slicedToArray$1(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var onChange = useCallback(function (_ref2) {
    var cookie = _ref2.cookie,
        active = _ref2.active;
    return dispatch({
      type: ACTIONS.COOKIE,
      payload: {
        cookie: cookie,
        active: active
      }
    });
  }, [dispatch]);
  var onSettings = useCallback(function () {
    return dispatch({
      type: ACTIONS.SETTINGS
    });
  }, [dispatch]);
  var onAccept = useCallback(function () {
    // set cookie
    setCookie(CONFIG.COOKIE.CONSENT, 'yes'); // set cookie by groups

    state.cookies.forEach(function (c) {
      return setCookie("jt_cookie_".concat(c), 'yes');
    }); // bus event with selected cookies

    eventBus.dispatch(CONFIG.EVENT.COOKIES_CONSENT, {
      cookies: state.cookies
    });
  }, [state.cookies]);
  var onReject = useCallback(function () {
    // set cookie
    setCookie(CONFIG.COOKIE.CONSENT, 'no'); // bus event with no cookies

    eventBus.dispatch(CONFIG.EVENT.COOKIES_CONSENT, {
      cookies: []
    });
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "modal",
    className: styles$1.modal
  }, /*#__PURE__*/React.createElement(Component$6, null), state.settings && /*#__PURE__*/React.createElement(Component$3, {
    cookies: state.cookies,
    onChange: onChange
  }), /*#__PURE__*/React.createElement(Component$2, {
    settings: state.settings,
    onSettings: onSettings,
    onAccept: onAccept,
    onReject: onReject
  }));
};

var styles = {"container":"Container__container__1yBAN","modal":"Container__modal__1yBAN"};

var Component = function Component() {
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "container",
    className: styles.container
  }, /*#__PURE__*/React.createElement(Component$7, null), /*#__PURE__*/React.createElement("div", {
    className: styles.modal
  }, /*#__PURE__*/React.createElement(Component$1, null)));
};

/* eslint-disable */
// CustomEvent polyfill

(function () {
  if (typeof window.CustomEvent === 'function') return false;

  function CustomEvent(event, params) {
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: null
    };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  window.CustomEvent = CustomEvent;
})();

export { Component as CookieManager, eventBus as EventBus };
//# sourceMappingURL=index.esm.js.map
